import { Injectable } from '@angular/core';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { Observable, of, zip } from 'rxjs';
import { InspectionPlugin } from '../../../shared/models';
import { FunctionPipe } from '../bobstcontact/function.pipe';
import { flatMap, map } from 'rxjs/operators';

@Injectable()
export class InstallationSignaturePluginService extends InspectionPluginService {
  private signatureTypeKeys: any = [
    { value: 1, label: 'plugins.installationsignature.customer' },
    { value: 2, label: 'plugins.installationsignature.bobst' }
  ];

  private signatureTypes: any = [];
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    protected factory: InspectionFactoryService,
    private language: LanguageService,
    private bobstFunctionPipe: FunctionPipe
  ) {
    super(apiService, dataService, null, factory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  public updateSignature(inspectionId: string, pointId: string, pluginId: string, anilox: any[]): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, anilox).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public getSignatureTypes() {
    return this.signatureTypes;
  }

  public applyTranslations() {
    this.signatureTypes = [];
    this.copyTranslationValues(this.signatureTypeKeys, this.signatureTypes, this.language);
  }

  public getCustomerContacts(inspectionId: string): Observable<any[]> {
    return zip(
      this.dataService.getInspectionLevelPlugin(inspectionId, 'installationcustomerattendees'),
      this.dataService.getParrentInspectionLevelPlugin(inspectionId, 'installationcustomercontact')
    ).pipe(
      map(([p, p1]) =>
        p?.config?.Attendees?.length ? [...p.config.Attendees] : [...(p1?.config?.CustomerContacts ?? [])]
      ),
      map((contacts) => contacts.map((c) => ({ ...c, Type: 1 })))
    );
  }

  public getBobstContacts(inspectionId: string): Observable<any[]> {
    return zip(
      this.dataService.getInspectionLevelPlugin(inspectionId, 'installationbobstattendees'),
      this.dataService.getParrentInspectionLevelPlugin(inspectionId, 'installationbobstcontact')
    ).pipe(
      map(([p, p1]) => {
        if (p?.config?.Attendees?.length) return [...p?.config?.Attendees.map((a) => ({ ...a, Type: 2 }))];

        return [...(p1?.config?.Team ?? [])].map((t) => ({
          Email: t.Email,
          Phone: t.Phone,
          JobFunction: t.Function ? this.bobstFunctionPipe.transform(t.Function) : '',
          FirstName: t.Name,
          LastName: t.LastName,
          Type: 2
        }));
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, signatures: any[]): Observable<any> {
    return this.factory.updatePluginConfig(inspectionId, pointId, pluginId, signatures, 'Signatures').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
